{
  "user_list": {
    "navigation_title": "Lista",
    "details": "Detalles del Usuario",
    "manage_roles": "Gestionar Roles"
  }
}
